import React, { useEffect } from "react";
import { Option, OptionsWrapper, TabView } from "./layoutOptionsStyles";
import { useDispatch } from "react-redux";
import { updateTab } from "store/reducers/QuotesPageReducer";
import { useAppSelector } from "hooks/redux";
import { addTab, IGrid } from "store/reducers/TabsSlice";
import copyName from "utils/copyName/copyName";
import { calcWorkspacesQuantity } from "utils/calcWorkspacesQuantity";
import { Panel, useDragContext } from "components/drag";
import { setGrid, setOrder } from "store/reducers/quotes";

const LayoutOptions = ({ tabNumber = 1 }) => {
    const dispatch = useDispatch();

    const onOptionClick = (
        number: number,
        flexDir: string,
        optionId: IGrid,
        order?: number[],
    ) => {
        //console.log('onOptionClick from onDragEnd',number, flexDir,optionId, order)

        const request_body: any = {
            grid: optionId,
        };

        if (order) {
            request_body.order = order;
        }
        dispatch(setGrid(optionId));
        if (order) {
            dispatch(setOrder(order));
        }
        dispatch(updateTab(request_body));
    };

    const currentOrder = useAppSelector((state) => state.quotes.order);

    const currentGrid = useAppSelector((state) => state.quotes.grid);

    // useEffect(() => {
    //     onOptionClick(tabNumber, "row", currentGrid, currentOrder);
    // }, []);

    useEffect(() => {
        switch (tabNumber) {
            case 1:
                if (currentGrid !== "1-0")
                    onOptionClick(tabNumber, "row", "1-0");
                break;
            case 2:
                if (currentGrid !== "2-0" && currentGrid !== "1-1")
                    onOptionClick(tabNumber, "row", "2-0", currentOrder);
                break;
            case 3:
                if (currentGrid !== "1-2" && currentGrid !== "3-0")
                    onOptionClick(3, "row", "1-2", currentOrder);
                break;
            case 4:
                if (currentGrid !== "2-2" && currentGrid !== "4-0")
                    onOptionClick(tabNumber, "row", "2-2", currentOrder);
                break;
        }
    }, [tabNumber]);

    switch (tabNumber) {
        case 1:
            return (
                <>
                    <Panel
                        type={"c"}
                        quantity={1}
                        onDragEnd={(order: number[]) => {
                            onOptionClick(tabNumber, "row", "1-0", order);
                        }}
                    />
                </>
            );
        case 2:
            return (
                <>
                    <Panel
                        type={"a"}
                        quantity={2}
                        onDragEnd={(order: number[]) => {
                            onOptionClick(tabNumber, "row", "2-0", order);
                        }}
                    />
                    <br />
                    <Panel
                        type={"b"}
                        quantity={2}
                        onDragEnd={(order: number[]) =>
                            onOptionClick(tabNumber, "column", "1-1", order)
                        }
                    />
                </>
            );
        case 3:
            return (
                <>
                    <Panel
                        type={"x"}
                        quantity={3}
                        onDragEnd={(order: number[]) =>
                            onOptionClick(3, "row", "1-2", order)
                        }
                    />
                    <br />
                    <Panel
                        type={"z"}
                        quantity={3}
                        onDragEnd={(order: number[]) =>
                            onOptionClick(tabNumber, "row", "3-0", order)
                        }
                    />
                </>
            );
        case 4:
            return (
                <>
                    <Panel
                        type={"d"}
                        quantity={4}
                        onDragEnd={(order: number[]) =>
                            onOptionClick(tabNumber, "row", "2-2", order)
                        }
                    />
                    <br />
                    <Panel
                        type={"e"}
                        quantity={4}
                        onDragEnd={(order: number[]) =>
                            onOptionClick(tabNumber, "row", "4-0", order)
                        }
                    />
                </>
            );
        default:
            return null;
    }
};

export default LayoutOptions;
